import { Navigate } from "react-router-dom";

/**
 * Buffer listing landing page — redirects to the unified products catalog
 * with the Buffer filter pre-applied (mirrors the dane
 * `buffer-products/page.tsx`). Wire at route path `/buffered`.
 */
export function BufferProductsPage() {
  return <Navigate to="/products?category=buffer" replace />;
}
